import request from './request.js';
import {requestbody} from './request.js'

export async function queryExportBusinessSituation(params = {}) {
    return await requestbody('/manuscript/queryExportBusinessSituation', 'post', params)
}

export async function saveExportBusinessSituation(params = {}) {
    return await requestbody('/manuscript/saveExportBusinessSituation', 'post', params)
}

export async function queryCurrentPeriodExportBusinessSituation(params = {}) {
    return await requestbody('/manuscript/queryCurrentPeriodExportBusinessSituation', 'post', params)
}